import { render } from "./footer.vue?vue&type=template&id=190819fd"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=190819fd&lang=css"
script.render = render

export default script